import { Comparator } from "react-bootstrap-table2-filter";
import { FaPrescriptionBottle } from "react-icons/fa";
import { grades } from "../constants";
import { IGraduationPrognosis } from "../types/types";
import { Prognosis, UserDataForecastId, tryParseInt } from "../utilities";

const positiveGrades = [ "A", "B", "C", "D", "E" ];
const positivePrognosis = [ Prognosis.enum[3].id, Prognosis.enum[4].id, Prognosis.enum[5].id ]
const numberOfHPCoreCourses: any = { "SVA": 3, "SVE": 3, "ENG": 2, "MAT": 1}
const middleSchoolCoreReq : { [id:string]: string[]} = { SVE: ["SV"], SVA: ["SVA"], ENG: ["EN"], MAT: ["MA"] }
const middleSchoolCoreCourseIds = ["SV", "SVA", "MA", "EN"];

const gradeWeight: { [id:string]: number } = { A: 10, B: 8, C: 6, D: 4, E: 2, F: 0 }

export function GetGraduationPrognosisData (graduationPrognosis: IGraduationPrognosis, className: string): any[] {
    console.log({graduationPrognosis})
    let programCourses: any = {};
    let individualCourses: any = {};
    let programType: string | undefined;
    let now = new Date;
    let nowString: string = now.toLocaleDateString('sv');

    graduationPrognosis.programMandatoryCourses.forEach(e => 
        programCourses[e.courseFilterMask] = { id: e.courseFilterMask, displayName: e.courseDisplayName, type: e.courseType }
    );

    let coreSubjects: any = { 
        SVE: { courses: [], filter: "SVE", minReq: [] /*"SVE%1"*/ },
        SVA: { courses: [], filter: "SVA", minReq: [] /*"SVA%1"*/ },
        ENG: { courses: [], filter: "ENG", minReq: [] /*"ENG%5"*/ },
        MAT: { courses: [], filter: "MAT", minReq: [] /*"MAT%1%"*/ }
    }

    graduationPrognosis.programMandatoryCourses.forEach(e => {
        programType = e.type;
    })

    //console.log({graduationPrognosis});
    //console.log({programMandatoryCourses: graduationPrognosis.programMandatoryCourses, programTypes: graduationPrognosis.programMandatoryCourses.map(e => e.type)});

    const programCourseFilter = graduationPrognosis.programMandatoryCourses.map(e => {
        const subject = e.courseFilterMask.slice(0, 3);

        if(coreSubjects[subject] != undefined)
            coreSubjects[subject].courses.push(e.courseFilterMask);

        return e.courseFilterMask;
    });

    //Retrieving the min required core subject courses
    Object.keys(coreSubjects).forEach(key => {
        const sorted = coreSubjects[key].courses.sort((a: string, b: string) => a.replace(/[^(1-9]/g, '') < b.replace(/[^(1-9]/g, '') ? -1 : 1);
    
        coreSubjects[key].courseNumbers = 
            coreSubjects[key].courses
            .map((e: string) => e.replace(/[^(1-9|1-9a-z)]/g, ''));

        switch (programType) {
            case "HP":
                const subject = key.slice(0, 3);
                const take: number = numberOfHPCoreCourses[subject] || 1;

                coreSubjects[key].minReq = sorted.slice(0, take);
                break;
            case "YP":
                coreSubjects[key].minReq = sorted.slice(0, 1) || coreSubjects[key].minReq;
                break;
            case "-": default:
                coreSubjects[key].minReq = middleSchoolCoreReq[key];
                break;
        }
    });

    let year = 0;

    switch (programType) {
        case "HP":
        case "YP":

            let numbers = className.match( /\d+/);
            let num = tryParseInt(numbers != null && numbers.length > 0 ? numbers[0] : "0", 0);

            let date = new Date();
            let currYear = date.getFullYear();
            let currMonth = date.getMonth();

            year = (currYear % 100) - num + (currMonth > 5 ? 1 : 0);
            break;
        default:
            break;
    }

    const transformedPrognosis = graduationPrognosis.studentView.map((e, index) => {
        var coursedata: any = {};
        var programPoints = 0;
        var totalPoints = 0;
        var invalidPoints = 0;
        var invalidCourses = 0;
        var failedMandatoryPoints = 0;
        var modernLangPoints = 0;
        var meritList = [];
        var avrgPoints = [];
        var diplomaWorkComplete = false;
        var coreSubjectsComplete = { 
            SVE: programType == "HP" ? [true, true, true] : [true], 
            MAT: [true], 
            ENG: programType == "HP" ? [true, true] : [true] 
        }

        let filteredForecasts: any = {};

        if(programType == '-' || programType == undefined) {
            //Grundskola
            let groupedForecasts: {[id:string]:any[]} = {};
            for(var i = 0; i < e.studentForecastView.length; i++) {
                const forecast = e.studentForecastView[i];
                groupedForecasts[forecast.courseName] = [...(groupedForecasts[forecast.courseName] || []), forecast];
            }
            
            for(const courseName in groupedForecasts) {
                groupedForecasts[courseName] = groupedForecasts[courseName].sort((a, b) => a.endDate > b.endDate ? -1 : 1).slice(0, 2);
                
                let forecast = groupedForecasts[courseName][0];

                //if the latest course has passed and the schoolyear of the course is not 1-5, then the course should not be displayed in the left-side of the matrix
                forecast.inactive = forecast.endDate < nowString && forecast.schoolYear >= "6";

                if(groupedForecasts[courseName].length > 1 && grades.indexOf(forecast.grade) == -1) {
                    forecast.grade = groupedForecasts[courseName][1].grade;
                    forecast.checkProgFirst = true;
                }
                
                filteredForecasts[courseName] = forecast;
            }
        }
        else {
            for(var i = 0; i < e.studentForecastView.length; i++) {
                const forecast = e.studentForecastView[i];
                if(filteredForecasts[forecast.courseName] != undefined) {
                    filteredForecasts[forecast.courseName] = internal.getHighestForecast(filteredForecasts[forecast.courseName], forecast, programType || '');
                }
                else {
                    filteredForecasts[forecast.courseName] = forecast;
                }
            }
        }

        const filteredForecastsArr = Object.keys(filteredForecasts).map(key => filteredForecasts[key]);
        let langMeritPoints = undefined;
        let msValidCourseCount = 0;

        for(var i = 0; i < filteredForecastsArr.length; i++) {
            const forecast = filteredForecastsArr[i];
            let programWide = false;
            let isProgramCourse = false;

            coursedata[forecast.courseName] = {
                grade: forecast.grade,
                prognosis: forecast.prognosis,
                prevPrognosis: forecast.prevPrognosis,
                inactive: forecast.inactive || false
            }
            
            coursedata[forecast.courseName + '_prognosis' ] = forecast.prognosis;

            if(programCourseFilter.indexOf(forecast.courseName) == -1) {
                individualCourses[forecast.courseName] = { 
                    id: forecast.courseName,
                    displayName: forecast.courseName
                };
            } else {
                isProgramCourse = programCourses[forecast.courseName]?.type == 'PGÄ';
                //Program/highschool specific course
                programWide = true;
            }

            const arePointsValid = internal.checkValidPoints(forecast.grade || "", forecast.prognosis || 0, forecast.checkProgFirst);

            if(arePointsValid === "OK")                    
            {
                coreSubjectsComplete = internal.calcCoreSubjectCompletion(forecast.courseName, coreSubjects, coreSubjectsComplete);
                if(middleSchoolCoreCourseIds.indexOf(forecast.courseName) == -1)
                    msValidCourseCount += 1;
            }
            else {
                coreSubjectsComplete = internal.calcCoreSubjectCompletion(forecast.courseName, coreSubjects, coreSubjectsComplete, false);
            }
            
            const validPoints = arePointsValid === "OK" ? 
                                    forecast.points
                                : 0;

            if(programWide && forecast.courseName.startsWith('GYAR') && arePointsValid === "OK") {
                // checks for programWide to make sure it is the correct diplomawork
                diplomaWorkComplete = true
            }

            programPoints += isProgramCourse ? validPoints : 0;
            totalPoints += validPoints;
            invalidPoints += arePointsValid != "NOT-OK" ? 0 : forecast.points;
            invalidCourses += arePointsValid == "OK" ? 0 : 1;

            let isModernLang = forecast.courseName.startsWith("MOD");
            if(isModernLang && arePointsValid == "OK")
                modernLangPoints += forecast.points;
            
            let isMandatoryCourse = programCourses[forecast.courseName] != undefined;
            if(isMandatoryCourse && arePointsValid == "NOT-OK")
                failedMandatoryPoints += forecast.points;
            

            if(forecast.points && (forecast.grade || (forecast.prognosis && forecast.prognosis != 5))) {
                avrgPoints.push(internal.meritPoints(forecast.grade, forecast.prognosis, forecast.courseName));
            }

            if(forecast.courseName.startsWith("M2") && langMeritPoints === undefined) {
                langMeritPoints = internal.meritPoints(forecast.grade, forecast.prognosis, forecast.courseName, forecast.checkProgFirst);
            }
            else {
                meritList.push(internal.meritPoints(forecast.grade, forecast.prognosis, forecast.courseName, forecast.checkProgFirst));
            }
        }

        //Is modernlang mandatory
        if(modernLangPoints < 100 && programCourses["MOD*"] != undefined)
            failedMandatoryPoints += 100

        if(programType && programType != e.programType)
            console.warn("Difference in program types between the students...", e.programType, programType);

        programType = internal.getHighestProgramType(programType || "", e.programType);

        //TODO
        const hsAveragePoints = avrgPoints.length > 0 ? avrgPoints.reduce((acc: number, e: any) => {
            return acc + e.points;
        }, 0) / avrgPoints.length : 0;

        const merit = meritList
            .sort((a: any, b: any) => b.points - a.points)
            .slice(0, 16)
            .reduce((acc, e) => {
                    return ({
                        points: acc.points + e.points, 
                        uncertain: acc.uncertain || e.uncertain
                    })
                }, 
                { points: langMeritPoints?.points || 0, uncertain: false })

        let msNoFailedCourses = invalidCourses == 0;//Object.keys(coursedata)
            //.map(key => coursedata[key])
            //.reduce((acc: boolean, c: { grade: string, prognosis: null | number}) => (acc && internal.checkValidPoints(c.grade || "", c.prognosis || 0, true) == "OK"), true);

        return { 
            dataIndex: index,
            name: `${e.firstName} ${e.lastName}`,
            gender: e.gender,
            socialSecurityNumber: e.socialSecurityNumber,
            coreSubjectsComplete: internal.evalCorSubjects(coreSubjectsComplete),
            totalPoints,
            programPoints,
            exam: internal.evalExam(e.programType, coreSubjectsComplete, totalPoints, programPoints, failedMandatoryPoints, invalidPoints, diplomaWorkComplete, year),
            invalidPoints,
            programType: e.programType,
            programName: e.programName,
            merit: merit,
            allGoals: msValidCourseCount >= 8 && coreSubjectsComplete && msNoFailedCourses,
            hsAveragePoints: hsAveragePoints,
            msValidCourseCount,
            "MOD*": {grade: '', prognosis: modernLangPoints < 100 ? 1 : 4},
            ...coursedata
        };
    });

    return transformedPrognosis.sort((a, b) => a.name < b.name ? -1 : 0);
}

abstract class internal {
    
    public static checkValidPoints = function (grade: string, prognosis: number, checkProgFirst: boolean = false) {
        //ugly last minute code
        if(checkProgFirst) {
            return prognosis != null && prognosis != 0 && prognosis != 5 ?
                (positivePrognosis.indexOf(prognosis) != -1) ?
                    "OK"
                : "NOT-OK"
            : grade != undefined && grade != "" ?
                (positiveGrades.indexOf(grade) != -1) ?
                    "OK"
                : "NOT-OK"
            : "OK";//"UNDEFINED";
        }

        return grade != undefined && grade != "" ?
                (positiveGrades.indexOf(grade) != -1) ?
                    "OK"
                : "NOT-OK"
            : prognosis ?
                (positivePrognosis.indexOf(prognosis) != -1) ?
                    "OK"
                : "NOT-OK"
            : "OK";//"UNDEFINED";
    }

    public static meritPoints = function (grade: string | null, prognosis: number | null, courseName: string, checkProgFirst: boolean = false) {
        
        if(checkProgFirst) {
            if(prognosis != null && prognosis != 0 && prognosis != 5) {
                return {
                    points: prognosis ? Prognosis.enum[prognosis].score : 0,
                    uncertain: true,
                    courseName
                }
            } else {
                const score: any = { "A": 20, "B": 17.5, "C": 15, "D": 12.5, "E": 10, "F": 0 }
                return {
                    points: grade ? score[grade] || 0 : 0,
                    uncertain: false,
                    courseName
                };
            }
        }
        
        if(grade && grade != "") {
            const score: any = { "A": 20, "B": 17.5, "C": 15, "D": 12.5, "E": 10, "F": 0 }
            return {
                points: score[grade] || 0,
                uncertain: false,
                courseName
            };
        } else {
            return {
                points: prognosis ? Prognosis.enum[prognosis].score : 0,
                uncertain: true,
                courseName
            }
        }
    }

    public static evalExam = function (programType: string, coreSubjectsComplete: any, totalPoints: number, programPoints: number, failedPoints: number, invalidPoints: number, diplomaWorkComplete: boolean, year: number) {
        
        switch (programType) {
            case "HP":
                return (
                    internal.evalCorSubjects(coreSubjectsComplete)
                    && (year < 3 || totalPoints >= 2250)
                    && (year > 2 || invalidPoints <= 250)
                    && (year < 3 || diplomaWorkComplete)
                    && (failedPoints <= 250)
                );
            case "YP":
                if (
                    internal.evalCorSubjects(coreSubjectsComplete)
                    && (year < 3 || totalPoints >= 2250)
                    && (year > 2 || invalidPoints <= 250)
                    && programPoints >= 400
                    && (year < 3 || diplomaWorkComplete)
                ) {
                    //console.log({SVE: coreSubjectsComplete.SVE, MAT: coreSubjectsComplete.MAT, EN: coreSubjectsComplete.ENG})
                    return true;
                }
                else {
                    //console.log({year, totalPoints, invalidPoints, programPoints, diplomaWorkComplete})
                    return false;
                }
            default:
        }
    
        return false;
    }

    public static calcCoreSubjectCompletion = function (courseName: string, coreSubjects: any, coreSubjectsComplete: any, success: boolean = true) {
        const subject = courseName.slice(0, 3);
    
        //Regex controlls replicating SQL 'LIKE' operator
        switch (subject) {
            case "SVA":
                coreSubjects["SVA"].minReq.forEach((elem: string, index: number) => {
                    if(new RegExp(elem.replace("%", ".*").replace("_", ".")).exec(courseName) != null)
                        coreSubjectsComplete["SVE"][index] = success;
                });
                break;
            case "SVE": case "SV":
                coreSubjects["SVE"].minReq.forEach((elem: string, index: number) => {
                    if(new RegExp(elem.replace("%", ".*").replace("_", ".")).exec(courseName) != null)
                        coreSubjectsComplete["SVE"][index] = success;
                });
                break;
            case "MAT": case "MA":
                if(coreSubjects["MAT"].minReq == undefined || coreSubjects["MAT"].minReq.length == 0) 
                    break;

                const minReqMathCourse = coreSubjects["MAT"].minReq[0].replace(/[^1-9a-z]/g, '');
                const mathCourse = courseName.replace(/[^1-9a-z]/g, '');

                if(minReqMathCourse.slice(0, 1) == mathCourse.slice(0, 1) && minReqMathCourse <= mathCourse) {
                    coreSubjectsComplete["MAT"][0] = success;
                }

                break;
            case "ENG": case "EN":
                coreSubjects["ENG"].minReq.forEach((elem: string, index: number) => {
                    if(new RegExp(elem.replace("%", ".*").replace("_", ".")).exec(courseName) != null)
                        coreSubjectsComplete["ENG"][index] = success;
                });
                break;
        }

        return coreSubjectsComplete;
    }

    public static evalCorSubjects = function (coreSubjectsComplete: any) {
        let result = true;

        Object.keys(coreSubjectsComplete).forEach(key => {
            result = result && coreSubjectsComplete[key].reduce(((e: boolean, acc: boolean) => e && acc), true)
        })

        return result;
    }

    public static getHighestProgramType = function (programTypeA: string, programTypeB: string) {
        if(programTypeA == programTypeB)
            return programTypeA;
        else if (programTypeA == "HP" || programTypeB == "HP")
            return "HP";
        else if (programTypeB == "YP" || programTypeB == "YP")
            return "YP";
        else
            return programTypeB;
    }

    public static getHighestForecast = function (forecastA: any, forecastB: any, programType: string) {
        if(programType == '-') {
            //if(forecastA.endDate > forecastB.endDate)
            //    return forecastA;
            //return forecastB;
        }

        const weightA: number = gradeWeight[forecastA.grade] || -1;
        const weightB: number = gradeWeight[forecastB.grade] || -1;

        return weightA > weightB ? forecastA : forecastB;
    }
}